import produce from 'immer';
import { AppCreationScreens, AppCreationTypes, } from './models';
import { faBars } from '@fortawesome/pro-duotone-svg-icons/faBars';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faSortAmountDown } from '@fortawesome/pro-regular-svg-icons/faSortAmountDown';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
export var getInitialState = function () { return ({
    open: false,
    previousStep: null,
    currentStep: AppCreationScreens.SELECT_TYPE,
    nextStep: AppCreationScreens.SET_NAME_AND_ICON,
    creationType: AppCreationTypes.SCRATCH,
    error: false,
    loading: false,
    loadingMessage: 'Customizing app...',
    progress: 0,
    name: '',
    logo: '',
    isNoQuotaOpen: false,
    isNameEmpty: false,
    openedColorPopup: {
        id: null,
        open: false,
    },
    openedTemplateInfo: false,
    openedCancelPopUp: false,
    footerContent: null,
    data: {
        backgroundColor: '#ffffff',
        secondaryBackgroundColor: '#ffffff',
        primaryColor: '#36e0b7',
        secondaryColor: '#0e3951',
        topBarColor: '#ececec',
        topBarColor2: '',
        topBarGradient: false,
        topBarGradientCutoff: 1,
        topBarBackgroundImage: '',
        topBarBackgroundImageSize: '',
        topBarDrawerButtonIcon: faBars,
        topBarDrawerButtonColor: '#ffffff',
        topBarDrawerButtonBackgroundColor: '#36e0b7',
        topBarDrawerButtonBorderColor: '#ffffff',
        topBarDrawerButtonBorderWidth: 0,
        topBarDrawerButtonBorderRadius: 0,
        topBarDrawerButtonBorderLeftColor: '#ffffff',
        topBarDrawerButtonBorderLeftWidth: 0,
        topBarDrawerButtonBorderRightColor: '#ffffff',
        topBarDrawerButtonBorderRightWidth: 0,
        topBarDrawerButtonBorderTopColor: '#ffffff',
        topBarDrawerButtonBorderTopWidth: 0,
        topBarDrawerButtonBorderBottomColor: '#ffffff',
        topBarDrawerButtonBorderBottomWidth: 0,
        topBarDrawerButtonBorderStyle: 'solid',
        topBarDrawerButtonBorderTopLeftRadius: 0,
        topBarDrawerButtonBorderTopRightRadius: 0,
        topBarDrawerButtonBorderBottomLeftRadius: 0,
        topBarDrawerButtonBorderBottomRightRadius: 0,
        topBarBackButtonIcon: faAngleLeft,
        topBarBackButtonColor: '#ffffff',
        topBarBackButtonBackgroundColor: '#36e0b7',
        topBarBackButtonBorderLeftColor: '#ffffff',
        topBarBackButtonBorderLeftWidth: 0,
        topBarBackButtonBorderRightColor: '#ffffff',
        topBarBackButtonBorderRightWidth: 0,
        topBarBackButtonBorderTopColor: '#ffffff',
        topBarBackButtonBorderTopWidth: 0,
        topBarBackButtonBorderBottomColor: '#ffffff',
        topBarBackButtonBorderBottomWidth: 0,
        topBarBackButtonBorderStyle: 'solid',
        topBarBackButtonBorderTopLeftRadius: 0,
        topBarBackButtonBorderTopRightRadius: 0,
        topBarBackButtonBorderBottomLeftRadius: 0,
        topBarBackButtonBorderBottomRightRadius: 0,
        topBarPreviousButtonIcon: faAngleLeft,
        topBarPreviousButtonColor: '#ffffff',
        topBarPreviousButtonBackgroundColor: '#36e0b7',
        topBarPreviousButtonBorderLeftColor: '#ffffff',
        topBarPreviousButtonBorderLeftWidth: 0,
        topBarPreviousButtonBorderRightColor: '#ffffff',
        topBarPreviousButtonBorderRightWidth: 0,
        topBarPreviousButtonBorderTopColor: '#ffffff',
        topBarPreviousButtonBorderTopWidth: 0,
        topBarPreviousButtonBorderBottomColor: '#ffffff',
        topBarPreviousButtonBorderBottomWidth: 0,
        topBarPreviousButtonBorderStyle: 'solid',
        topBarPreviousButtonBorderTopLeftRadius: 0,
        topBarPreviousButtonBorderTopRightRadius: 0,
        topBarPreviousButtonBorderBottomLeftRadius: 0,
        topBarPreviousButtonBorderBottomRightRadius: 0,
        topBarNextButtonIcon: faAngleRight,
        topBarNextButtonColor: '#ffffff',
        topBarNextButtonBackgroundColor: '#36e0b7',
        topBarNextButtonBorderLeftColor: '#ffffff',
        topBarNextButtonBorderLeftWidth: 0,
        topBarNextButtonBorderRightColor: '#ffffff',
        topBarNextButtonBorderRightWidth: 0,
        topBarNextButtonBorderTopColor: '#ffffff',
        topBarNextButtonBorderTopWidth: 0,
        topBarNextButtonBorderBottomColor: '#ffffff',
        topBarNextButtonBorderBottomWidth: 0,
        topBarNextButtonBorderStyle: 'solid',
        topBarNextButtonBorderTopLeftRadius: 0,
        topBarNextButtonBorderTopRightRadius: 0,
        topBarNextButtonBorderBottomLeftRadius: 0,
        topBarNextButtonBorderBottomRightRadius: 0,
        topBarSortButtonIcon: faSortAmountDown,
        topBarSortButtonColor: '#ffffff',
        topBarSortButtonBackgroundColor: '#36E0B7',
        topBarSortButtonBorderLeftColor: '#ffffff',
        topBarSortButtonBorderLeftWidth: 0,
        topBarSortButtonBorderRightColor: '#ffffff',
        topBarSortButtonBorderRightWidth: 0,
        topBarSortButtonBorderTopColor: '#ffffff',
        topBarSortButtonBorderTopWidth: 0,
        topBarSortButtonBorderBottomColor: '#ffffff',
        topBarSortButtonBorderBottomWidth: 0,
        topBarSortButtonBorderStyle: 'solid',
        topBarSortButtonBorderTopLeftRadius: 0,
        topBarSortButtonBorderTopRightRadius: 0,
        topBarSortButtonBorderBottomLeftRadius: 0,
        topBarSortButtonBorderBottomRightRadius: 0,
        topBarContextButtonIcon: faEllipsisV,
        topBarContextButtonColor: '#ffffff',
        topBarContextButtonBackgroundColor: '#36E0B7',
        topBarContextButtonBorderLeftColor: '#ffffff',
        topBarContextButtonBorderLeftWidth: 0,
        topBarContextButtonBorderRightColor: '#ffffff',
        topBarContextButtonBorderRightWidth: 0,
        topBarContextButtonBorderTopColor: '#ffffff',
        topBarContextButtonBorderTopWidth: 0,
        topBarContextButtonBorderBottomColor: '#ffffff',
        topBarContextButtonBorderBottomWidth: 0,
        topBarContextButtonBorderStyle: 'solid',
        topBarContextButtonBorderTopLeftRadius: 0,
        topBarContextButtonBorderTopRightRadius: 0,
        topBarContextButtonBorderBottomLeftRadius: 0,
        topBarContextButtonBorderBottomRightRadius: 0,
        topBarAddButtonIcon: faPlus,
        topBarAddButtonColor: '#ffffff',
        topBarAddButtonBackgroundColor: '#36E0B7',
        topBarAddButtonBorderLeftColor: '#ffffff',
        topBarAddButtonBorderLeftWidth: 0,
        topBarAddButtonBorderRightColor: '#ffffff',
        topBarAddButtonBorderRightWidth: 0,
        topBarAddButtonBorderTopColor: '#ffffff',
        topBarAddButtonBorderTopWidth: 0,
        topBarAddButtonBorderBottomColor: '#ffffff',
        topBarAddButtonBorderBottomWidth: 0,
        topBarAddButtonBorderStyle: 'solid',
        topBarAddButtonBorderTopLeftRadius: 0,
        topBarAddButtonBorderTopRightRadius: 0,
        topBarAddButtonBorderBottomLeftRadius: 0,
        topBarAddButtonBorderBottomRightRadius: 0,
        topBarCarouselIndicatorBorderWidth: 0,
        topBarCarouselIndicatorBorderStyle: 'solid',
        topBarCarouselIndicatorBorderColor: '#ffffff',
        topBarCarouselIndicatorBackgroundColor: '#cccccc',
        topBarCarouselIndicatorBackgroundOpacity: 100,
        topBarCarouselIndicatorSelectedBorderWidth: 0,
        topBarCarouselIndicatorSelectedBorderStyle: 'solid',
        topBarCarouselIndicatorSelectedBorderColor: '#ffffff',
        topBarCarouselIndicatorSelectedBackgroundColor: '#cccccc',
        topBarCarouselIndicatorSelectedBackgroundOpacity: 100,
        menuBackgroundColor: '#ffffff',
        menuBackgroundColor2: '',
        menuBackgroundGradient: false,
        menuSelectedItemColor: 'transparent',
        menuBackgroundGradientCutoff: 1,
        menuBackgroundImage: '',
        menuBackgroundImageSize: '',
        subMenuBarBackgroundColor: '#ececec',
        subMenuBarBackgroundColor2: '',
        subMenuBarBackgroundGradient: false,
        subMenuBarBackgroundGradientCutoff: 1,
        subMenuBarBackgroundImage: '',
        subMenuBarBackgroundImageSize: 'cover',
        subMenuBarBackgroundPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuBarBackgroundBorderLeftColor: '#ffffff',
        subMenuBarBackgroundBorderLeftWidth: 0,
        subMenuBarBackgroundBorderRightColor: '#ffffff',
        subMenuBarBackgroundBorderRightWidth: 0,
        subMenuBarBackgroundBorderTopColor: '#ffffff',
        subMenuBarBackgroundBorderTopWidth: 0,
        subMenuBarBackgroundBorderBottomColor: '#ffffff',
        subMenuBarBackgroundBorderBottomWidth: 0,
        subMenuBarBackgroundBorderStyle: 'solid',
        subMenuBarBackgroundBorderTopLeftRadius: 0,
        subMenuBarBackgroundBorderTopRightRadius: 0,
        subMenuBarBackgroundBorderBottomLeftRadius: 0,
        subMenuBarBackgroundBorderBottomRightRadius: 0,
        subMenuButtonBackgroundColor: '#ececec',
        subMenuButtonFlexDirection: 'row',
        subMenuButtonJustifyContent: 'center',
        subMenuButtonAlignItems: 'center',
        subMenuButtonPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonBorderLeftColor: '#ffffff',
        subMenuButtonBorderLeftWidth: 0,
        subMenuButtonBorderRightColor: '#ffffff',
        subMenuButtonBorderRightWidth: 0,
        subMenuButtonBorderTopColor: '#ffffff',
        subMenuButtonBorderTopWidth: 0,
        subMenuButtonBorderBottomColor: '#ffffff',
        subMenuButtonBorderBottomWidth: 0,
        subMenuButtonBorderStyle: 'solid',
        subMenuButtonBorderTopLeftRadius: 0,
        subMenuButtonBorderTopRightRadius: 0,
        subMenuButtonBorderBottomLeftRadius: 0,
        subMenuButtonBorderBottomRightRadius: 0,
        subMenuButtonSelectedBackgroundColor: '#ececec',
        subMenuButtonSelectedFlexDirection: 'row',
        subMenuButtonSelectedJustifyContent: 'center',
        subMenuButtonSelectedAlignItems: 'center',
        subMenuButtonSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonSelectedBorderLeftColor: '#ffffff',
        subMenuButtonSelectedBorderLeftWidth: 0,
        subMenuButtonSelectedBorderRightColor: '#ffffff',
        subMenuButtonSelectedBorderRightWidth: 0,
        subMenuButtonSelectedBorderTopColor: '#ffffff',
        subMenuButtonSelectedBorderTopWidth: 0,
        subMenuButtonSelectedBorderBottomColor: '#ffffff',
        subMenuButtonSelectedBorderBottomWidth: 0,
        subMenuButtonSelectedBorderStyle: 'solid',
        subMenuButtonSelectedBorderTopLeftRadius: 0,
        subMenuButtonSelectedBorderTopRightRadius: 0,
        subMenuButtonSelectedBorderBottomLeftRadius: 0,
        subMenuButtonSelectedBorderBottomRightRadius: 0,
        subMenuButtonTextFontFamily: 'System',
        subMenuButtonTextFontWeight: 'normal',
        subMenuButtonTextFontColor: '#000000',
        subMenuButtonTextFontSize: 18,
        subMenuButtonTextFontStyle: 'normal',
        subMenuButtonTextTextDecoration: 'none',
        subMenuButtonTextTextTransform: 'none',
        subMenuButtonTextTextShadowColor: '#ffffff',
        subMenuButtonTextTextShadowRadius: 0,
        subMenuButtonTextLetterSpacing: 0,
        subMenuButtonTextNumberOfLines: 1,
        subMenuButtonTextEllipsizeMode: 'tail',
        subMenuButtonTextFlexDirection: 'row',
        subMenuButtonTextJustifyContent: 'center',
        subMenuButtonTextAlignItems: 'center',
        subMenuButtonTextPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonTextBorderLeftColor: '#ffffff',
        subMenuButtonTextBorderLeftWidth: 0,
        subMenuButtonTextBorderRightColor: '#ffffff',
        subMenuButtonTextBorderRightWidth: 0,
        subMenuButtonTextBorderTopColor: '#ffffff',
        subMenuButtonTextBorderTopWidth: 0,
        subMenuButtonTextBorderBottomColor: '#ffffff',
        subMenuButtonTextBorderBottomWidth: 0,
        subMenuButtonTextBorderStyle: 'solid',
        subMenuButtonTextBorderTopLeftRadius: 0,
        subMenuButtonTextBorderTopRightRadius: 0,
        subMenuButtonTextBorderBottomLeftRadius: 0,
        subMenuButtonTextBorderBottomRightRadius: 0,
        subMenuButtonTextSelectedFontFamily: 'System',
        subMenuButtonTextSelectedFontWeight: 'normal',
        subMenuButtonTextSelectedFontColor: '#000000',
        subMenuButtonTextSelectedFontSize: 18,
        subMenuButtonTextSelectedFontStyle: 'normal',
        subMenuButtonTextSelectedTextDecoration: 'none',
        subMenuButtonTextSelectedTextTransform: 'none',
        subMenuButtonTextSelectedTextShadowColor: '#ffffff',
        subMenuButtonTextSelectedTextShadowRadius: 0,
        subMenuButtonTextSelectedLetterSpacing: 0,
        subMenuButtonTextSelectedNumberOfLines: 1,
        subMenuButtonTextSelectedEllipsizeMode: 'tail',
        subMenuButtonTextSelectedFlexDirection: 'row',
        subMenuButtonTextSelectedJustifyContent: 'center',
        subMenuButtonTextSelectedAlignItems: 'center',
        subMenuButtonTextSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonTextSelectedBorderLeftColor: '#ffffff',
        subMenuButtonTextSelectedBorderLeftWidth: 0,
        subMenuButtonTextSelectedBorderRightColor: '#ffffff',
        subMenuButtonTextSelectedBorderRightWidth: 0,
        subMenuButtonTextSelectedBorderTopColor: '#ffffff',
        subMenuButtonTextSelectedBorderTopWidth: 0,
        subMenuButtonTextSelectedBorderBottomColor: '#ffffff',
        subMenuButtonTextSelectedBorderBottomWidth: 0,
        subMenuButtonTextSelectedBorderStyle: 'solid',
        subMenuButtonTextSelectedBorderTopLeftRadius: 0,
        subMenuButtonTextSelectedBorderTopRightRadius: 0,
        subMenuButtonTextSelectedBorderBottomLeftRadius: 0,
        subMenuButtonTextSelectedBorderBottomRightRadius: 0,
        tabBarBackgroundColor: '#ececec',
        tabBarBackgroundColor2: '',
        tabBarBackgroundGradient: false,
        tabBarBackgroundGradientCutoff: 1,
        tabBarBackgroundImage: '',
        tabBarBackgroundImageSize: 'cover',
        tabBarBackgroundPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabBarBackgroundBorderLeftColor: '#ffffff',
        tabBarBackgroundBorderLeftWidth: 0,
        tabBarBackgroundBorderRightColor: '#ffffff',
        tabBarBackgroundBorderRightWidth: 0,
        tabBarBackgroundBorderTopColor: '#ffffff',
        tabBarBackgroundBorderTopWidth: 0,
        tabBarBackgroundBorderBottomColor: '#ffffff',
        tabBarBackgroundBorderBottomWidth: 0,
        tabBarBackgroundBorderStyle: 'solid',
        tabBarBackgroundBorderTopLeftRadius: 0,
        tabBarBackgroundBorderTopRightRadius: 0,
        tabBarBackgroundBorderBottomLeftRadius: 0,
        tabBarBackgroundBorderBottomRightRadius: 0,
        tabButtonBackgroundColor: '#ececec',
        tabButtonFlexDirection: 'row',
        tabButtonJustifyContent: 'center',
        tabButtonAlignItems: 'center',
        tabButtonPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonBorderLeftColor: '#ffffff',
        tabButtonBorderLeftWidth: 0,
        tabButtonBorderRightColor: '#ffffff',
        tabButtonBorderRightWidth: 0,
        tabButtonBorderTopColor: '#ffffff',
        tabButtonBorderTopWidth: 0,
        tabButtonBorderBottomColor: '#ffffff',
        tabButtonBorderBottomWidth: 0,
        tabButtonBorderStyle: 'solid',
        tabButtonBorderTopLeftRadius: 0,
        tabButtonBorderTopRightRadius: 0,
        tabButtonBorderBottomLeftRadius: 0,
        tabButtonBorderBottomRightRadius: 0,
        tabButtonSelectedBackgroundColor: '#ececec',
        tabButtonSelectedFlexDirection: 'row',
        tabButtonSelectedJustifyContent: 'center',
        tabButtonSelectedAlignItems: 'center',
        tabButtonSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonSelectedBorderLeftColor: '#ffffff',
        tabButtonSelectedBorderLeftWidth: 0,
        tabButtonSelectedBorderRightColor: '#ffffff',
        tabButtonSelectedBorderRightWidth: 0,
        tabButtonSelectedBorderTopColor: '#ffffff',
        tabButtonSelectedBorderTopWidth: 0,
        tabButtonSelectedBorderBottomColor: '#ffffff',
        tabButtonSelectedBorderBottomWidth: 0,
        tabButtonSelectedBorderStyle: 'solid',
        tabButtonSelectedBorderTopLeftRadius: 0,
        tabButtonSelectedBorderTopRightRadius: 0,
        tabButtonSelectedBorderBottomLeftRadius: 0,
        tabButtonSelectedBorderBottomRightRadius: 0,
        tabButtonTextFontFamily: 'System',
        tabButtonTextFontWeight: 'normal',
        tabButtonTextFontColor: '#000000',
        tabButtonTextFontSize: 18,
        tabButtonTextFontStyle: 'normal',
        tabButtonTextTextDecoration: 'none',
        tabButtonTextTextTransform: 'none',
        tabButtonTextTextShadowColor: '#ffffff',
        tabButtonTextTextShadowRadius: 0,
        tabButtonTextLetterSpacing: 0,
        tabButtonTextNumberOfLines: 1,
        tabButtonTextEllipsizeMode: 'tail',
        tabButtonTextFlexDirection: 'row',
        tabButtonTextJustifyContent: 'center',
        tabButtonTextAlignItems: 'center',
        tabButtonTextPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonTextBorderLeftColor: '#ffffff',
        tabButtonTextBorderLeftWidth: 0,
        tabButtonTextBorderRightColor: '#ffffff',
        tabButtonTextBorderRightWidth: 0,
        tabButtonTextBorderTopColor: '#ffffff',
        tabButtonTextBorderTopWidth: 0,
        tabButtonTextBorderBottomColor: '#ffffff',
        tabButtonTextBorderBottomWidth: 0,
        tabButtonTextBorderStyle: 'solid',
        tabButtonTextBorderTopLeftRadius: 0,
        tabButtonTextBorderTopRightRadius: 0,
        tabButtonTextBorderBottomLeftRadius: 0,
        tabButtonTextBorderBottomRightRadius: 0,
        tabButtonTextSelectedFontFamily: 'System',
        tabButtonTextSelectedFontWeight: 'normal',
        tabButtonTextSelectedFontColor: '#000000',
        tabButtonTextSelectedFontSize: 18,
        tabButtonTextSelectedFontStyle: 'normal',
        tabButtonTextSelectedTextDecoration: 'none',
        tabButtonTextSelectedTextTransform: 'none',
        tabButtonTextSelectedTextShadowColor: '#ffffff',
        tabButtonTextSelectedTextShadowRadius: 0,
        tabButtonTextSelectedLetterSpacing: 0,
        tabButtonTextSelectedNumberOfLines: 1,
        tabButtonTextSelectedEllipsizeMode: 'tail',
        tabButtonTextSelectedFlexDirection: 'row',
        tabButtonTextSelectedJustifyContent: 'center',
        tabButtonTextSelectedAlignItems: 'center',
        tabButtonTextSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonTextSelectedBorderLeftColor: '#ffffff',
        tabButtonTextSelectedBorderLeftWidth: 0,
        tabButtonTextSelectedBorderRightColor: '#ffffff',
        tabButtonTextSelectedBorderRightWidth: 0,
        tabButtonTextSelectedBorderTopColor: '#ffffff',
        tabButtonTextSelectedBorderTopWidth: 0,
        tabButtonTextSelectedBorderBottomColor: '#ffffff',
        tabButtonTextSelectedBorderBottomWidth: 0,
        tabButtonTextSelectedBorderStyle: 'solid',
        tabButtonTextSelectedBorderTopLeftRadius: 0,
        tabButtonTextSelectedBorderTopRightRadius: 0,
        tabButtonTextSelectedBorderBottomLeftRadius: 0,
        tabButtonTextSelectedBorderBottomRightRadius: 0,
        tabButtonIconColor: '#ffffff',
        tabButtonIconPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonIconSelectedColor: '#ffffff',
        tabButtonIconSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        calendarBackground: '#ffffff',
        calendarTextSectionTitleColor: '#b6c1cd',
        calendarSelectedDayBackgroundColor: '#36e0b7',
        calendarSelectedDayTextColor: '#000000',
        calendarTodayTextColor: '#000000',
        calendarDayTextColor: '#2d4150',
        calendarTextDisabledColor: '#d9e1e8',
        calendarMonthTextColor: '#2d4150',
        calendarTextDayFontFamily: 'System',
        calendarTextDayFontSize: 16,
        calendarTextDayFontWeight: '300',
        calendarTextMonthFontFamily: 'System',
        calendarTextMonthFontWeight: 'bold',
        calendarTextMonthFontSize: 16,
        calendarTextDayHeaderFontFamily: 'System',
        calendarTextDayHeaderFontWeight: '300',
        calendarTextDayHeaderFontSize: 16,
        calendarMonthNextButtonIcon: faAngleRight,
        calendarMonthNextButtonIconColor: '#000000',
        calendarMonthPreviousButtonIcon: faAngleLeft,
        calendarMonthPreviousButtonIconColor: '#000000',
        supportingColor1: '#619863',
        supportingColor2: '#13958e',
        supportingColor3: '#eeeeee',
        searchBarColor: 'transparent',
        searchBackgroundColor: 'transparent',
        headerFontFamily: 'System',
        headerFontWeight: 'bold',
        headerFontColor: '#000000',
        headerFontSize: 18,
        headerFontStyle: 'normal',
        headerTextDecoration: 'none',
        headerTextTransform: 'none',
        headerTextShadowColor: 'transparent',
        headerTextShadowRadius: 0,
        headerLetterSpacing: 0,
        headerNumberOfLines: 1,
        headerEllipsizeMode: 'clip',
        menuFontFamily: 'System',
        menuFontWeight: 'bold',
        menuFontColor: '#000000',
        menuFontSize: 18,
        menuFontStyle: 'normal',
        menuTextDecoration: 'none',
        menuTextTransform: 'none',
        menuTextShadowColor: 'transparent',
        menuTextShadowRadius: 0,
        menuLetterSpacing: 0,
        menuNumberOfLines: 1,
        menuEllipsizeMode: 'clip',
        bodyFontFamily: 'System',
        bodyFontWeight: 'normal',
        bodyFontColor: '#222222',
        bodyFontSize: 14,
        bodyFontStyle: 'normal',
        bodyTextDecoration: 'none',
        bodyTextTransform: 'none',
        bodyTextShadowColor: 'transparent',
        bodyTextShadowRadius: 0,
        bodyLetterSpacing: 0,
        bodyNumberOfLines: 1,
        bodyEllipsizeMode: 'clip',
        borderLeftColor: '#cccccc',
        borderLeftWidth: 1,
        borderRightColor: '#cccccc',
        borderRightWidth: 1,
        borderTopColor: '#cccccc',
        borderTopWidth: 1,
        borderBottomColor: '#cccccc',
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        paddings: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
        },
        transition: {
            type: 'none',
            duration: '250',
        },
        drawerShadow: false,
        swatches: [
            '#000000',
            '#ffffff',
            '#ff0000',
            '#00ff00',
            '#0000ff',
            '#36e0b7',
            '#0e3951',
            '#ff00ff',
            '#00ffff',
            '#f0f0f0',
        ],
        colorStyles: [
            { id: 'color:1', name: 'Primary', value: '#0FC08D' },
            { id: 'color:2', name: 'Primary Shade', value: '#0B906A' },
            { id: 'color:3', name: 'Secondary', value: '#0F96C0' },
            { id: 'color:4', name: 'Secondary Shade', value: '#0B7190' },
            { id: 'color:5', name: 'Background', value: '#F8F8FB' },
            { id: 'color:6', name: 'Text', value: '#252525' },
            { id: 'color:7', name: 'Subtext', value: '#696969' },
            { id: 'color:8', name: 'Info', value: '#7496EB' },
            { id: 'color:9', name: 'Warning', value: '#FF9966' },
            { id: 'color:10', name: 'Error', value: '#FF6666' },
        ],
        textStyles: [
            {
                id: 'text:1',
                name: 'Title 1',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 24,
                    fontWeight: '700',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:2',
                name: 'Title 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 24,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:3',
                name: 'Title 3',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 22,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:4',
                name: 'Title 4',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 22,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:5',
                name: 'Subtitle 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:6',
                name: 'Subtitle 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:7',
                name: 'Body Text 1',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:8',
                name: 'Body Text 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 16,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:9',
                name: 'Button Text',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 16,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:10',
                name: 'Subtext',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 12,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
        ],
    },
    selectedTemplate: {
        id: '',
        colorView: null,
        typographyView: null,
        icon: '',
        appId: '',
        includeData: false,
        version: null,
    },
    templates: [],
    templateName: '',
    templateType: null,
    version: null,
    perPage: 16,
    page: 1,
    templateLoading: false,
    templateError: false,
    templateInfo: {
        id: '',
        name: '',
        description: '',
        summary: '',
        icon: '',
        media: {
            videos: '',
            images: [],
        },
        version: 18,
        categories: [],
        template_tags: [],
        app: '',
        type: '',
        preview: { color: '', typography: '' },
        meta: { include_data: false, website_link: '' },
    },
    categories: [],
    categoriesLoading: false,
    categoriesError: false,
    searchText: '',
    solutionTemplates: [],
    conceptTemplates: [],
    functionTemplates: [],
    legacyTemplates: [],
    categoryString: '',
    templateCategories: {
        solutions: [],
        concepts: [],
        functions: [],
        legacy: [],
        solutionsCurrentPage: 1,
        solutionsTotalPages: null,
        solutionsLoading: false,
        solutionsError: false,
        conceptsCurrentPage: 1,
        conceptsTotalPages: null,
        conceptsLoading: false,
        conceptsError: false,
        functionsCurrentPage: 1,
        functionsTotalPages: null,
        functionsLoading: false,
        functionsError: false,
        legacyCurrentPage: 1,
        legacyTotalPages: null,
        legacyLoading: false,
        legacyError: false,
    },
    searchType: null,
    activeSearchResults: [],
    activeSearchCurrentPage: 1,
    activeSearchTotalPages: 1,
    activeSearchLoading: false,
    activeSearchError: false,
    activeSearchTotalTemplates: 0,
    createdTemplateApp: {
        id: '',
        styleId: '',
    },
    createdApp: {},
    newerVersion: 18,
    legacyVersion: 17,
    deleteLoading: false,
    deleteError: false,
    environmentData: [],
    environmentLoading: false,
    environmentError: false,
    environmentEditData: [],
    environmentDataLoading: false,
    environmentDataError: false,
    requestTemplate: false,
    allRequiredEnvs: false,
    isContinueDisabled: false,
    styleData: null,
    styleName: 'Theme 1',
    styleDescription: 'Default theme',
    styleDataLoading: false,
    styleDataError: false,
}); };
function createAppFlowReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'SET_OPEN_APP_FLOW':
                state.open = true;
                break;
            case 'SET_CLOSE_APP_FLOW':
                state.open = false;
                break;
            case 'SET_APP_CREATION_FLOW_ERROR':
                state.error = true;
                break;
            case 'SET_APP_CREATION_STEP':
                state.previousStep = action.previous;
                state.nextStep = action.next;
                state.currentStep = action.step;
                state.creationType = action.createType;
                break;
            case 'SET_APP_NAME':
                state.name = action.name;
                break;
            case 'SET_APP_LOGO':
                state.logo = action.logo;
                break;
            case 'SET_APP_NAME_IS_EMPTY':
                state.isNameEmpty = action.isNameEmpty;
                break;
            case 'SET_APP_COLOR':
                state.data.colorStyles[action.index].value = action.value;
                state.data.colorStyles[action.index].name = action.name;
                break;
            case 'SET_APP_TEXT':
                state.data.textStyles[action.index].values.fontFamily =
                    action.fontFamily;
                state.data.textStyles[action.index].values.fontSize = action.fontSize;
                state.data.textStyles[action.index].values.fontWeight =
                    action.fontWeight;
                state.data.textStyles[action.index].values.letterSpacing =
                    action.letterSpacing;
                state.data.textStyles[action.index].name = action.name;
                break;
            case 'SET_COLOR_POPUP':
                state.openedColorPopup.id = action.id;
                state.openedColorPopup.open = action.open;
                break;
            case 'SET_CONFIRM_CLOSE':
                state.openedCancelPopUp = action.open;
                break;
            case 'SET_TEMPLATE_INFO':
                state.openedTemplateInfo = action.open;
                break;
            case 'SET_FOOTER_CONTENT':
                state.footerContent = action.content;
                break;
            case 'SET_SELECTED_TEMPLATE':
                state.selectedTemplate.id = action.templateId;
                state.selectedTemplate.colorView = action.templateColor;
                state.selectedTemplate.typographyView = action.templateTypography;
                state.selectedTemplate.icon = action.templateIcon;
                state.selectedTemplate.appId = action.templateAppId;
                state.selectedTemplate.includeData = action.templateIncludeData;
                state.selectedTemplate.version = action.templateVersion;
                break;
            case 'RESET_APP_CREATION_STATE':
                state.open = false;
                state.previousStep = null;
                state.currentStep = AppCreationScreens.SELECT_TYPE;
                state.nextStep = AppCreationScreens.SET_NAME_AND_ICON;
                state.creationType = AppCreationTypes.SCRATCH;
                state.error = false;
                state.loading = false;
                state.loadingMessage = 'Customizing app...';
                state.progress = 0;
                state.name = '';
                state.logo = '';
                state.isNoQuotaOpen = false;
                state.isNameEmpty = false;
                state.openedColorPopup = {
                    id: null,
                    open: false,
                };
                state.openedTemplateInfo = false;
                state.openedCancelPopUp = false;
                state.footerContent = null;
                state.data = {
                    backgroundColor: '#ffffff',
                    secondaryBackgroundColor: '#ffffff',
                    primaryColor: '#36e0b7',
                    secondaryColor: '#0e3951',
                    topBarColor: '#ececec',
                    topBarColor2: '',
                    topBarGradient: false,
                    topBarGradientCutoff: 1,
                    topBarBackgroundImage: '',
                    topBarBackgroundImageSize: '',
                    topBarDrawerButtonIcon: faBars,
                    topBarDrawerButtonColor: '#ffffff',
                    topBarDrawerButtonBackgroundColor: '#36e0b7',
                    topBarDrawerButtonBorderColor: '#ffffff',
                    topBarDrawerButtonBorderWidth: 0,
                    topBarDrawerButtonBorderRadius: 0,
                    topBarDrawerButtonBorderLeftColor: '#ffffff',
                    topBarDrawerButtonBorderLeftWidth: 0,
                    topBarDrawerButtonBorderRightColor: '#ffffff',
                    topBarDrawerButtonBorderRightWidth: 0,
                    topBarDrawerButtonBorderTopColor: '#ffffff',
                    topBarDrawerButtonBorderTopWidth: 0,
                    topBarDrawerButtonBorderBottomColor: '#ffffff',
                    topBarDrawerButtonBorderBottomWidth: 0,
                    topBarDrawerButtonBorderStyle: 'solid',
                    topBarDrawerButtonBorderTopLeftRadius: 0,
                    topBarDrawerButtonBorderTopRightRadius: 0,
                    topBarDrawerButtonBorderBottomLeftRadius: 0,
                    topBarDrawerButtonBorderBottomRightRadius: 0,
                    topBarBackButtonIcon: faAngleLeft,
                    topBarBackButtonColor: '#ffffff',
                    topBarBackButtonBackgroundColor: '#36e0b7',
                    topBarBackButtonBorderLeftColor: '#ffffff',
                    topBarBackButtonBorderLeftWidth: 0,
                    topBarBackButtonBorderRightColor: '#ffffff',
                    topBarBackButtonBorderRightWidth: 0,
                    topBarBackButtonBorderTopColor: '#ffffff',
                    topBarBackButtonBorderTopWidth: 0,
                    topBarBackButtonBorderBottomColor: '#ffffff',
                    topBarBackButtonBorderBottomWidth: 0,
                    topBarBackButtonBorderStyle: 'solid',
                    topBarBackButtonBorderTopLeftRadius: 0,
                    topBarBackButtonBorderTopRightRadius: 0,
                    topBarBackButtonBorderBottomLeftRadius: 0,
                    topBarBackButtonBorderBottomRightRadius: 0,
                    topBarPreviousButtonIcon: faAngleLeft,
                    topBarPreviousButtonColor: '#ffffff',
                    topBarPreviousButtonBackgroundColor: '#36e0b7',
                    topBarPreviousButtonBorderLeftColor: '#ffffff',
                    topBarPreviousButtonBorderLeftWidth: 0,
                    topBarPreviousButtonBorderRightColor: '#ffffff',
                    topBarPreviousButtonBorderRightWidth: 0,
                    topBarPreviousButtonBorderTopColor: '#ffffff',
                    topBarPreviousButtonBorderTopWidth: 0,
                    topBarPreviousButtonBorderBottomColor: '#ffffff',
                    topBarPreviousButtonBorderBottomWidth: 0,
                    topBarPreviousButtonBorderStyle: 'solid',
                    topBarPreviousButtonBorderTopLeftRadius: 0,
                    topBarPreviousButtonBorderTopRightRadius: 0,
                    topBarPreviousButtonBorderBottomLeftRadius: 0,
                    topBarPreviousButtonBorderBottomRightRadius: 0,
                    topBarNextButtonIcon: faAngleRight,
                    topBarNextButtonColor: '#ffffff',
                    topBarNextButtonBackgroundColor: '#36e0b7',
                    topBarNextButtonBorderLeftColor: '#ffffff',
                    topBarNextButtonBorderLeftWidth: 0,
                    topBarNextButtonBorderRightColor: '#ffffff',
                    topBarNextButtonBorderRightWidth: 0,
                    topBarNextButtonBorderTopColor: '#ffffff',
                    topBarNextButtonBorderTopWidth: 0,
                    topBarNextButtonBorderBottomColor: '#ffffff',
                    topBarNextButtonBorderBottomWidth: 0,
                    topBarNextButtonBorderStyle: 'solid',
                    topBarNextButtonBorderTopLeftRadius: 0,
                    topBarNextButtonBorderTopRightRadius: 0,
                    topBarNextButtonBorderBottomLeftRadius: 0,
                    topBarNextButtonBorderBottomRightRadius: 0,
                    topBarSortButtonIcon: faSortAmountDown,
                    topBarSortButtonColor: '#ffffff',
                    topBarSortButtonBackgroundColor: '#36E0B7',
                    topBarSortButtonBorderLeftColor: '#ffffff',
                    topBarSortButtonBorderLeftWidth: 0,
                    topBarSortButtonBorderRightColor: '#ffffff',
                    topBarSortButtonBorderRightWidth: 0,
                    topBarSortButtonBorderTopColor: '#ffffff',
                    topBarSortButtonBorderTopWidth: 0,
                    topBarSortButtonBorderBottomColor: '#ffffff',
                    topBarSortButtonBorderBottomWidth: 0,
                    topBarSortButtonBorderStyle: 'solid',
                    topBarSortButtonBorderTopLeftRadius: 0,
                    topBarSortButtonBorderTopRightRadius: 0,
                    topBarSortButtonBorderBottomLeftRadius: 0,
                    topBarSortButtonBorderBottomRightRadius: 0,
                    topBarContextButtonIcon: faEllipsisV,
                    topBarContextButtonColor: '#ffffff',
                    topBarContextButtonBackgroundColor: '#36E0B7',
                    topBarContextButtonBorderLeftColor: '#ffffff',
                    topBarContextButtonBorderLeftWidth: 0,
                    topBarContextButtonBorderRightColor: '#ffffff',
                    topBarContextButtonBorderRightWidth: 0,
                    topBarContextButtonBorderTopColor: '#ffffff',
                    topBarContextButtonBorderTopWidth: 0,
                    topBarContextButtonBorderBottomColor: '#ffffff',
                    topBarContextButtonBorderBottomWidth: 0,
                    topBarContextButtonBorderStyle: 'solid',
                    topBarContextButtonBorderTopLeftRadius: 0,
                    topBarContextButtonBorderTopRightRadius: 0,
                    topBarContextButtonBorderBottomLeftRadius: 0,
                    topBarContextButtonBorderBottomRightRadius: 0,
                    topBarAddButtonIcon: faPlus,
                    topBarAddButtonColor: '#ffffff',
                    topBarAddButtonBackgroundColor: '#36E0B7',
                    topBarAddButtonBorderLeftColor: '#ffffff',
                    topBarAddButtonBorderLeftWidth: 0,
                    topBarAddButtonBorderRightColor: '#ffffff',
                    topBarAddButtonBorderRightWidth: 0,
                    topBarAddButtonBorderTopColor: '#ffffff',
                    topBarAddButtonBorderTopWidth: 0,
                    topBarAddButtonBorderBottomColor: '#ffffff',
                    topBarAddButtonBorderBottomWidth: 0,
                    topBarAddButtonBorderStyle: 'solid',
                    topBarAddButtonBorderTopLeftRadius: 0,
                    topBarAddButtonBorderTopRightRadius: 0,
                    topBarAddButtonBorderBottomLeftRadius: 0,
                    topBarAddButtonBorderBottomRightRadius: 0,
                    topBarCarouselIndicatorBorderWidth: 0,
                    topBarCarouselIndicatorBorderStyle: 'solid',
                    topBarCarouselIndicatorBorderColor: '#ffffff',
                    topBarCarouselIndicatorBackgroundColor: '#cccccc',
                    topBarCarouselIndicatorBackgroundOpacity: 100,
                    topBarCarouselIndicatorSelectedBorderWidth: 0,
                    topBarCarouselIndicatorSelectedBorderStyle: 'solid',
                    topBarCarouselIndicatorSelectedBorderColor: '#ffffff',
                    topBarCarouselIndicatorSelectedBackgroundColor: '#cccccc',
                    topBarCarouselIndicatorSelectedBackgroundOpacity: 100,
                    menuBackgroundColor: '#ffffff',
                    menuBackgroundColor2: '',
                    menuBackgroundGradient: false,
                    menuSelectedItemColor: 'transparent',
                    menuBackgroundGradientCutoff: 1,
                    menuBackgroundImage: '',
                    menuBackgroundImageSize: '',
                    subMenuBarBackgroundColor: '#ececec',
                    subMenuBarBackgroundColor2: '',
                    subMenuBarBackgroundGradient: false,
                    subMenuBarBackgroundGradientCutoff: 1,
                    subMenuBarBackgroundImage: '',
                    subMenuBarBackgroundImageSize: 'cover',
                    subMenuBarBackgroundPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    subMenuBarBackgroundBorderLeftColor: '#ffffff',
                    subMenuBarBackgroundBorderLeftWidth: 0,
                    subMenuBarBackgroundBorderRightColor: '#ffffff',
                    subMenuBarBackgroundBorderRightWidth: 0,
                    subMenuBarBackgroundBorderTopColor: '#ffffff',
                    subMenuBarBackgroundBorderTopWidth: 0,
                    subMenuBarBackgroundBorderBottomColor: '#ffffff',
                    subMenuBarBackgroundBorderBottomWidth: 0,
                    subMenuBarBackgroundBorderStyle: 'solid',
                    subMenuBarBackgroundBorderTopLeftRadius: 0,
                    subMenuBarBackgroundBorderTopRightRadius: 0,
                    subMenuBarBackgroundBorderBottomLeftRadius: 0,
                    subMenuBarBackgroundBorderBottomRightRadius: 0,
                    subMenuButtonBackgroundColor: '#ececec',
                    subMenuButtonFlexDirection: 'row',
                    subMenuButtonJustifyContent: 'center',
                    subMenuButtonAlignItems: 'center',
                    subMenuButtonPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    subMenuButtonBorderLeftColor: '#ffffff',
                    subMenuButtonBorderLeftWidth: 0,
                    subMenuButtonBorderRightColor: '#ffffff',
                    subMenuButtonBorderRightWidth: 0,
                    subMenuButtonBorderTopColor: '#ffffff',
                    subMenuButtonBorderTopWidth: 0,
                    subMenuButtonBorderBottomColor: '#ffffff',
                    subMenuButtonBorderBottomWidth: 0,
                    subMenuButtonBorderStyle: 'solid',
                    subMenuButtonBorderTopLeftRadius: 0,
                    subMenuButtonBorderTopRightRadius: 0,
                    subMenuButtonBorderBottomLeftRadius: 0,
                    subMenuButtonBorderBottomRightRadius: 0,
                    subMenuButtonSelectedBackgroundColor: '#ececec',
                    subMenuButtonSelectedFlexDirection: 'row',
                    subMenuButtonSelectedJustifyContent: 'center',
                    subMenuButtonSelectedAlignItems: 'center',
                    subMenuButtonSelectedPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    subMenuButtonSelectedBorderLeftColor: '#ffffff',
                    subMenuButtonSelectedBorderLeftWidth: 0,
                    subMenuButtonSelectedBorderRightColor: '#ffffff',
                    subMenuButtonSelectedBorderRightWidth: 0,
                    subMenuButtonSelectedBorderTopColor: '#ffffff',
                    subMenuButtonSelectedBorderTopWidth: 0,
                    subMenuButtonSelectedBorderBottomColor: '#ffffff',
                    subMenuButtonSelectedBorderBottomWidth: 0,
                    subMenuButtonSelectedBorderStyle: 'solid',
                    subMenuButtonSelectedBorderTopLeftRadius: 0,
                    subMenuButtonSelectedBorderTopRightRadius: 0,
                    subMenuButtonSelectedBorderBottomLeftRadius: 0,
                    subMenuButtonSelectedBorderBottomRightRadius: 0,
                    subMenuButtonTextFontFamily: 'System',
                    subMenuButtonTextFontWeight: 'normal',
                    subMenuButtonTextFontColor: '#000000',
                    subMenuButtonTextFontSize: 18,
                    subMenuButtonTextFontStyle: 'normal',
                    subMenuButtonTextTextDecoration: 'none',
                    subMenuButtonTextTextTransform: 'none',
                    subMenuButtonTextTextShadowColor: '#ffffff',
                    subMenuButtonTextTextShadowRadius: 0,
                    subMenuButtonTextLetterSpacing: 0,
                    subMenuButtonTextNumberOfLines: 1,
                    subMenuButtonTextEllipsizeMode: 'tail',
                    subMenuButtonTextFlexDirection: 'row',
                    subMenuButtonTextJustifyContent: 'center',
                    subMenuButtonTextAlignItems: 'center',
                    subMenuButtonTextPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    subMenuButtonTextBorderLeftColor: '#ffffff',
                    subMenuButtonTextBorderLeftWidth: 0,
                    subMenuButtonTextBorderRightColor: '#ffffff',
                    subMenuButtonTextBorderRightWidth: 0,
                    subMenuButtonTextBorderTopColor: '#ffffff',
                    subMenuButtonTextBorderTopWidth: 0,
                    subMenuButtonTextBorderBottomColor: '#ffffff',
                    subMenuButtonTextBorderBottomWidth: 0,
                    subMenuButtonTextBorderStyle: 'solid',
                    subMenuButtonTextBorderTopLeftRadius: 0,
                    subMenuButtonTextBorderTopRightRadius: 0,
                    subMenuButtonTextBorderBottomLeftRadius: 0,
                    subMenuButtonTextBorderBottomRightRadius: 0,
                    subMenuButtonTextSelectedFontFamily: 'System',
                    subMenuButtonTextSelectedFontWeight: 'normal',
                    subMenuButtonTextSelectedFontColor: '#000000',
                    subMenuButtonTextSelectedFontSize: 18,
                    subMenuButtonTextSelectedFontStyle: 'normal',
                    subMenuButtonTextSelectedTextDecoration: 'none',
                    subMenuButtonTextSelectedTextTransform: 'none',
                    subMenuButtonTextSelectedTextShadowColor: '#ffffff',
                    subMenuButtonTextSelectedTextShadowRadius: 0,
                    subMenuButtonTextSelectedLetterSpacing: 0,
                    subMenuButtonTextSelectedNumberOfLines: 1,
                    subMenuButtonTextSelectedEllipsizeMode: 'tail',
                    subMenuButtonTextSelectedFlexDirection: 'row',
                    subMenuButtonTextSelectedJustifyContent: 'center',
                    subMenuButtonTextSelectedAlignItems: 'center',
                    subMenuButtonTextSelectedPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    subMenuButtonTextSelectedBorderLeftColor: '#ffffff',
                    subMenuButtonTextSelectedBorderLeftWidth: 0,
                    subMenuButtonTextSelectedBorderRightColor: '#ffffff',
                    subMenuButtonTextSelectedBorderRightWidth: 0,
                    subMenuButtonTextSelectedBorderTopColor: '#ffffff',
                    subMenuButtonTextSelectedBorderTopWidth: 0,
                    subMenuButtonTextSelectedBorderBottomColor: '#ffffff',
                    subMenuButtonTextSelectedBorderBottomWidth: 0,
                    subMenuButtonTextSelectedBorderStyle: 'solid',
                    subMenuButtonTextSelectedBorderTopLeftRadius: 0,
                    subMenuButtonTextSelectedBorderTopRightRadius: 0,
                    subMenuButtonTextSelectedBorderBottomLeftRadius: 0,
                    subMenuButtonTextSelectedBorderBottomRightRadius: 0,
                    tabBarBackgroundColor: '#ececec',
                    tabBarBackgroundColor2: '',
                    tabBarBackgroundGradient: false,
                    tabBarBackgroundGradientCutoff: 1,
                    tabBarBackgroundImage: '',
                    tabBarBackgroundImageSize: 'cover',
                    tabBarBackgroundPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    tabBarBackgroundBorderLeftColor: '#ffffff',
                    tabBarBackgroundBorderLeftWidth: 0,
                    tabBarBackgroundBorderRightColor: '#ffffff',
                    tabBarBackgroundBorderRightWidth: 0,
                    tabBarBackgroundBorderTopColor: '#ffffff',
                    tabBarBackgroundBorderTopWidth: 0,
                    tabBarBackgroundBorderBottomColor: '#ffffff',
                    tabBarBackgroundBorderBottomWidth: 0,
                    tabBarBackgroundBorderStyle: 'solid',
                    tabBarBackgroundBorderTopLeftRadius: 0,
                    tabBarBackgroundBorderTopRightRadius: 0,
                    tabBarBackgroundBorderBottomLeftRadius: 0,
                    tabBarBackgroundBorderBottomRightRadius: 0,
                    tabButtonBackgroundColor: '#ececec',
                    tabButtonFlexDirection: 'row',
                    tabButtonJustifyContent: 'center',
                    tabButtonAlignItems: 'center',
                    tabButtonPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    tabButtonBorderLeftColor: '#ffffff',
                    tabButtonBorderLeftWidth: 0,
                    tabButtonBorderRightColor: '#ffffff',
                    tabButtonBorderRightWidth: 0,
                    tabButtonBorderTopColor: '#ffffff',
                    tabButtonBorderTopWidth: 0,
                    tabButtonBorderBottomColor: '#ffffff',
                    tabButtonBorderBottomWidth: 0,
                    tabButtonBorderStyle: 'solid',
                    tabButtonBorderTopLeftRadius: 0,
                    tabButtonBorderTopRightRadius: 0,
                    tabButtonBorderBottomLeftRadius: 0,
                    tabButtonBorderBottomRightRadius: 0,
                    tabButtonSelectedBackgroundColor: '#ececec',
                    tabButtonSelectedFlexDirection: 'row',
                    tabButtonSelectedJustifyContent: 'center',
                    tabButtonSelectedAlignItems: 'center',
                    tabButtonSelectedPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    tabButtonSelectedBorderLeftColor: '#ffffff',
                    tabButtonSelectedBorderLeftWidth: 0,
                    tabButtonSelectedBorderRightColor: '#ffffff',
                    tabButtonSelectedBorderRightWidth: 0,
                    tabButtonSelectedBorderTopColor: '#ffffff',
                    tabButtonSelectedBorderTopWidth: 0,
                    tabButtonSelectedBorderBottomColor: '#ffffff',
                    tabButtonSelectedBorderBottomWidth: 0,
                    tabButtonSelectedBorderStyle: 'solid',
                    tabButtonSelectedBorderTopLeftRadius: 0,
                    tabButtonSelectedBorderTopRightRadius: 0,
                    tabButtonSelectedBorderBottomLeftRadius: 0,
                    tabButtonSelectedBorderBottomRightRadius: 0,
                    tabButtonTextFontFamily: 'System',
                    tabButtonTextFontWeight: 'normal',
                    tabButtonTextFontColor: '#000000',
                    tabButtonTextFontSize: 18,
                    tabButtonTextFontStyle: 'normal',
                    tabButtonTextTextDecoration: 'none',
                    tabButtonTextTextTransform: 'none',
                    tabButtonTextTextShadowColor: '#ffffff',
                    tabButtonTextTextShadowRadius: 0,
                    tabButtonTextLetterSpacing: 0,
                    tabButtonTextNumberOfLines: 1,
                    tabButtonTextEllipsizeMode: 'tail',
                    tabButtonTextFlexDirection: 'row',
                    tabButtonTextJustifyContent: 'center',
                    tabButtonTextAlignItems: 'center',
                    tabButtonTextPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    tabButtonTextBorderLeftColor: '#ffffff',
                    tabButtonTextBorderLeftWidth: 0,
                    tabButtonTextBorderRightColor: '#ffffff',
                    tabButtonTextBorderRightWidth: 0,
                    tabButtonTextBorderTopColor: '#ffffff',
                    tabButtonTextBorderTopWidth: 0,
                    tabButtonTextBorderBottomColor: '#ffffff',
                    tabButtonTextBorderBottomWidth: 0,
                    tabButtonTextBorderStyle: 'solid',
                    tabButtonTextBorderTopLeftRadius: 0,
                    tabButtonTextBorderTopRightRadius: 0,
                    tabButtonTextBorderBottomLeftRadius: 0,
                    tabButtonTextBorderBottomRightRadius: 0,
                    tabButtonTextSelectedFontFamily: 'System',
                    tabButtonTextSelectedFontWeight: 'normal',
                    tabButtonTextSelectedFontColor: '#000000',
                    tabButtonTextSelectedFontSize: 18,
                    tabButtonTextSelectedFontStyle: 'normal',
                    tabButtonTextSelectedTextDecoration: 'none',
                    tabButtonTextSelectedTextTransform: 'none',
                    tabButtonTextSelectedTextShadowColor: '#ffffff',
                    tabButtonTextSelectedTextShadowRadius: 0,
                    tabButtonTextSelectedLetterSpacing: 0,
                    tabButtonTextSelectedNumberOfLines: 1,
                    tabButtonTextSelectedEllipsizeMode: 'tail',
                    tabButtonTextSelectedFlexDirection: 'row',
                    tabButtonTextSelectedJustifyContent: 'center',
                    tabButtonTextSelectedAlignItems: 'center',
                    tabButtonTextSelectedPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    tabButtonTextSelectedBorderLeftColor: '#ffffff',
                    tabButtonTextSelectedBorderLeftWidth: 0,
                    tabButtonTextSelectedBorderRightColor: '#ffffff',
                    tabButtonTextSelectedBorderRightWidth: 0,
                    tabButtonTextSelectedBorderTopColor: '#ffffff',
                    tabButtonTextSelectedBorderTopWidth: 0,
                    tabButtonTextSelectedBorderBottomColor: '#ffffff',
                    tabButtonTextSelectedBorderBottomWidth: 0,
                    tabButtonTextSelectedBorderStyle: 'solid',
                    tabButtonTextSelectedBorderTopLeftRadius: 0,
                    tabButtonTextSelectedBorderTopRightRadius: 0,
                    tabButtonTextSelectedBorderBottomLeftRadius: 0,
                    tabButtonTextSelectedBorderBottomRightRadius: 0,
                    tabButtonIconColor: '#ffffff',
                    tabButtonIconPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    tabButtonIconSelectedColor: '#ffffff',
                    tabButtonIconSelectedPaddings: {
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                    },
                    calendarBackground: '#ffffff',
                    calendarTextSectionTitleColor: '#b6c1cd',
                    calendarSelectedDayBackgroundColor: '#36e0b7',
                    calendarSelectedDayTextColor: '#000000',
                    calendarTodayTextColor: '#000000',
                    calendarDayTextColor: '#2d4150',
                    calendarTextDisabledColor: '#d9e1e8',
                    calendarMonthTextColor: '#2d4150',
                    calendarTextDayFontFamily: 'System',
                    calendarTextDayFontSize: 16,
                    calendarTextDayFontWeight: '300',
                    calendarTextMonthFontFamily: 'System',
                    calendarTextMonthFontWeight: 'bold',
                    calendarTextMonthFontSize: 16,
                    calendarTextDayHeaderFontFamily: 'System',
                    calendarTextDayHeaderFontWeight: '300',
                    calendarTextDayHeaderFontSize: 16,
                    calendarMonthNextButtonIcon: faAngleRight,
                    calendarMonthNextButtonIconColor: '#000000',
                    calendarMonthPreviousButtonIcon: faAngleLeft,
                    calendarMonthPreviousButtonIconColor: '#000000',
                    supportingColor1: '#619863',
                    supportingColor2: '#13958e',
                    supportingColor3: '#eeeeee',
                    searchBarColor: 'transparent',
                    searchBackgroundColor: 'transparent',
                    headerFontFamily: 'System',
                    headerFontWeight: 'bold',
                    headerFontColor: '#000000',
                    headerFontSize: 18,
                    headerFontStyle: 'normal',
                    headerTextDecoration: 'none',
                    headerTextTransform: 'none',
                    headerTextShadowColor: 'transparent',
                    headerTextShadowRadius: 0,
                    headerLetterSpacing: 0,
                    headerNumberOfLines: 1,
                    headerEllipsizeMode: 'clip',
                    menuFontFamily: 'System',
                    menuFontWeight: 'bold',
                    menuFontColor: '#000000',
                    menuFontSize: 18,
                    menuFontStyle: 'normal',
                    menuTextDecoration: 'none',
                    menuTextTransform: 'none',
                    menuTextShadowColor: 'transparent',
                    menuTextShadowRadius: 0,
                    menuLetterSpacing: 0,
                    menuNumberOfLines: 1,
                    menuEllipsizeMode: 'clip',
                    bodyFontFamily: 'System',
                    bodyFontWeight: 'normal',
                    bodyFontColor: '#222222',
                    bodyFontSize: 14,
                    bodyFontStyle: 'normal',
                    bodyTextDecoration: 'none',
                    bodyTextTransform: 'none',
                    bodyTextShadowColor: 'transparent',
                    bodyTextShadowRadius: 0,
                    bodyLetterSpacing: 0,
                    bodyNumberOfLines: 1,
                    bodyEllipsizeMode: 'clip',
                    borderLeftColor: '#cccccc',
                    borderLeftWidth: 1,
                    borderRightColor: '#cccccc',
                    borderRightWidth: 1,
                    borderTopColor: '#cccccc',
                    borderTopWidth: 1,
                    borderBottomColor: '#cccccc',
                    borderBottomWidth: 1,
                    borderStyle: 'solid',
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    paddings: {
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                    },
                    transition: {
                        type: 'none',
                        duration: '250',
                    },
                    drawerShadow: false,
                    swatches: [
                        '#000000',
                        '#ffffff',
                        '#ff0000',
                        '#00ff00',
                        '#0000ff',
                        '#36e0b7',
                        '#0e3951',
                        '#ff00ff',
                        '#00ffff',
                        '#f0f0f0',
                    ],
                    colorStyles: [
                        { id: 'color:1', name: 'Primary', value: '#0FC08D' },
                        { id: 'color:2', name: 'Primary Shade', value: '#0B906A' },
                        { id: 'color:3', name: 'Secondary', value: '#0F96C0' },
                        { id: 'color:4', name: 'Secondary Shade', value: '#0B7190' },
                        { id: 'color:5', name: 'Background', value: '#F8F8FB' },
                        { id: 'color:6', name: 'Text', value: '#252525' },
                        { id: 'color:7', name: 'Subtext', value: '#696969' },
                        { id: 'color:8', name: 'Info', value: '#7496EB' },
                        { id: 'color:9', name: 'Warning', value: '#FF9966' },
                        { id: 'color:10', name: 'Error', value: '#FF6666' },
                    ],
                    textStyles: [
                        {
                            id: 'text:1',
                            name: 'Title 1',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 24,
                                fontWeight: '700',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:2',
                            name: 'Title 2',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 24,
                                fontWeight: '600',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:3',
                            name: 'Title 3',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 22,
                                fontWeight: '600',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:4',
                            name: 'Title 4',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 22,
                                fontWeight: '400',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:5',
                            name: 'Subtitle 2',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 18,
                                fontWeight: '400',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:6',
                            name: 'Subtitle 2',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 18,
                                fontWeight: '400',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:7',
                            name: 'Body Text 1',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 18,
                                fontWeight: '400',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:8',
                            name: 'Body Text 2',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 16,
                                fontWeight: '400',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:9',
                            name: 'Button Text',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 16,
                                fontWeight: '600',
                                letterSpacing: 0,
                            },
                        },
                        {
                            id: 'text:10',
                            name: 'Subtext',
                            values: {
                                fontFamily: 'Open Sans',
                                fontSize: 12,
                                fontWeight: '400',
                                letterSpacing: 0,
                            },
                        },
                    ],
                };
                state.selectedTemplate = {
                    id: '',
                    colorView: null,
                    typographyView: null,
                    icon: '',
                    appId: '',
                    includeData: false,
                    version: null,
                };
                state.templates = [];
                state.templateName = '';
                state.templateType = null;
                state.version = null;
                state.perPage = 16;
                state.page = 1;
                state.templateLoading = false;
                state.templateError = false;
                state.templateInfo = {
                    id: '',
                    name: '',
                    description: '',
                    summary: '',
                    icon: '',
                    media: {
                        videos: null,
                        images: [],
                    },
                    version: 18,
                    categories: [],
                    template_tags: [],
                    app: '',
                    type: '',
                    preview: { color: '', typography: '' },
                    meta: { include_data: false, website_link: '' },
                };
                state.categories = [];
                state.categoriesLoading = false;
                state.categoriesError = false;
                state.searchText = '';
                state.solutionTemplates = [];
                state.conceptTemplates = [];
                state.functionTemplates = [];
                state.legacyTemplates = [];
                state.categoryString = '';
                state.templateCategories = {
                    solutions: [],
                    concepts: [],
                    functions: [],
                    legacy: [],
                    solutionsCurrentPage: 1,
                    solutionsTotalPages: null,
                    solutionsLoading: false,
                    solutionsError: false,
                    conceptsCurrentPage: 1,
                    conceptsTotalPages: null,
                    conceptsLoading: false,
                    conceptsError: false,
                    functionsCurrentPage: 1,
                    functionsTotalPages: null,
                    functionsLoading: false,
                    functionsError: false,
                    legacyCurrentPage: 1,
                    legacyTotalPages: null,
                    legacyLoading: false,
                    legacyError: false,
                };
                state.searchType = null;
                state.activeSearchResults = [];
                state.activeSearchCurrentPage = 1;
                state.activeSearchTotalPages = 1;
                state.activeSearchLoading = false;
                state.activeSearchError = false;
                state.createdTemplateApp = {
                    id: '',
                    styleId: '',
                };
                state.activeSearchTotalTemplates = 0;
                state.newerVersion = 18;
                state.legacyVersion = 17;
                state.createdApp = {};
                state.deleteLoading = false;
                state.deleteError = false;
                state.environmentData = [];
                state.environmentLoading = false;
                state.environmentError = false;
                state.environmentDataLoading = false;
                state.environmentDataError = false;
                state.environmentEditData = [];
                state.requestTemplate = false;
                state.allRequiredEnvs = false;
                state.isContinueDisabled = false;
                state.styleData = null;
                state.styleName = 'Theme 1';
                state.styleDescription = 'Default theme';
                state.styleDataLoading = false;
                state.styleDataError = false;
                break;
            case 'SET_CREATE_APP_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'SET_CREATE_APP_SUCCESS':
                state.createdApp = action.app;
                state.loading = false;
                state.error = false;
                break;
            case 'SET_CREATE_APP_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'GET_APP_TEMPLATE_REQUEST':
                state.templateLoading = true;
                state.templateError = false;
                break;
            case 'GET_APP_TEMPLATE_SUCCESS':
                state.templates = action.templates;
                state.solutionTemplates = action.solutionTemplates;
                state.conceptTemplates = action.conceptTemplates;
                state.functionTemplates = action.functionTemplates;
                state.legacyTemplates = action.legacyTemplates;
                state.templateLoading = false;
                state.templateError = false;
                break;
            case 'GET_APP_TEMPLATE_FAILURE':
                state.templateLoading = false;
                state.templateError = true;
                break;
            case 'GET_INITIAL_TEMPLATES_REQUEST':
                state.templateCategories.solutionsLoading = true;
                state.templateCategories.conceptsLoading = true;
                state.templateCategories.functionsLoading = true;
                state.templateCategories.legacyLoading = true;
                state.templateCategories.solutionsError = false;
                state.templateCategories.conceptsError = false;
                state.templateCategories.functionsError = false;
                state.templateCategories.legacyError = false;
                break;
            case 'GET_INITIAL_TEMPLATES_SUCCESS':
                state.templateCategories.solutions = action.solutionsArr;
                state.templateCategories.concepts = action.conceptsArr;
                state.templateCategories.functions = action.functionsArr;
                state.templateCategories.legacy = action.legacyArr;
                state.templateCategories.solutionsLoading = false;
                state.templateCategories.conceptsLoading = false;
                state.templateCategories.functionsLoading = false;
                state.templateCategories.legacyLoading = false;
                state.templateCategories.solutionsError = false;
                state.templateCategories.conceptsError = false;
                state.templateCategories.functionsError = false;
                state.templateCategories.legacyError = false;
                break;
            case 'GET_INITIAL_TEMPLATES_FAILURE':
                state.templateCategories.solutionsError = true;
                state.templateCategories.conceptsError = true;
                state.templateCategories.functionsError = true;
                state.templateCategories.legacyError = true;
                state.templateCategories.solutionsLoading = false;
                state.templateCategories.conceptsLoading = false;
                state.templateCategories.functionsLoading = false;
                state.templateCategories.legacyLoading = false;
                break;
            case 'SET_TEMPLATE_MORE_INFO':
                state.templateInfo = action.info;
                break;
            case 'GET_ORG_CATEGORIES_REQUEST':
                state.categoriesLoading = true;
                state.categoriesError = false;
                break;
            case 'GET_ORG_CATEGORIES_SUCCESS':
                state.categories = action.categories;
                state.categoriesLoading = false;
                state.categoriesError = false;
                break;
            case 'GET_ORG_CATEGORIES_FAILURE':
                state.categoriesLoading = false;
                state.categoriesError = true;
                break;
            case 'SET_SELECTED_CATEGORIES':
                state.categories[action.categoryIndex].selected =
                    action.categorySelection;
                break;
            case 'SET_SELECTED_TYPE':
                state.templateType = action.name;
                break;
            case 'SET_SEARCH_TEXT':
                state.searchText = action.text;
                break;
            case 'SET_CATEGORY_TEXT':
                state.categoryString = action.text;
                break;
            case 'GET_CATEGORIZED_TEMPLATES_REQUEST':
                state.templateCategories[action.templateLoadingType] = true;
                state.templateCategories[action.templateErrorType] = false;
                break;
            case 'Set_CATEGORIZED_TEMPLATES_SUCCESS':
                state.templateCategories[action.templateType] = action.templateData;
                state.templateCategories[action.templateLoadingType] = false;
                state.templateCategories[action.templateErrorType] = false;
                break;
            case 'GET_CATEGORIZED_TEMPLATES_FAILURE':
                state.templateCategories[action.templateLoadingType] = false;
                state.templateCategories[action.templateErrorType] = true;
                break;
            case 'SET_SEARCH_TYPE':
                state.searchType = action.searchType;
                break;
            case 'SET_TYPE_PAGE_NUMBER':
                state.templateCategories[action.pageType] = action.pageNumber;
                state.templateCategories[action.pagesTotalType] = action.pagesTotal;
                break;
            case 'CLEAR_AND_SEARCH_FILTERS':
                state.templateCategories.solutions = action.solutions;
                state.templateCategories.concepts = action.concepts;
                state.templateCategories.functions = action.functions;
                state.templateCategories.legacy = action.legacy;
                state.templateCategories.solutionsCurrentPage =
                    action.solutionsCurrentPage;
                state.templateCategories.solutionsTotalPages =
                    action.solutionsTotalPages;
                state.templateCategories.solutionsLoading = action.solutionsLoading;
                state.templateCategories.solutionsError = action.solutionsError;
                state.templateCategories.conceptsCurrentPage =
                    action.conceptsCurrentPage;
                state.templateCategories.conceptsTotalPages = action.conceptsTotalPages;
                state.templateCategories.conceptsLoading = action.conceptsLoading;
                state.templateCategories.conceptsError = action.conceptsError;
                state.templateCategories.functionsCurrentPage =
                    action.functionsCurrentPage;
                state.templateCategories.functionsTotalPages =
                    action.functionsTotalPages;
                state.templateCategories.functionsLoading = action.functionsLoading;
                state.templateCategories.functionsError = action.functionsError;
                state.templateCategories.legacyCurrentPage = action.legacyCurrentPage;
                state.templateCategories.legacyTotalPages = action.legacyTotalPages;
                state.templateCategories.legacyLoading = action.legacyLoading;
                state.templateCategories.legacyError = action.legacyError;
                break;
            case 'ACTIVE_SEARCH_RESULTS_REQUEST':
                state.activeSearchLoading = true;
                state.activeSearchError = false;
                break;
            case 'ACTIVE_SEARCH_RESULTS_SUCCESS':
                state.activeSearchResults = action.results;
                state.activeSearchCurrentPage = action.currentPage;
                state.activeSearchTotalPages = action.totalPages;
                state.activeSearchTotalTemplates = action.templateCount;
                state.activeSearchLoading = false;
                state.activeSearchError = false;
                break;
            case 'ACTIVE_SEARCH_RESULTS_FAILURE':
                state.activeSearchLoading = false;
                state.activeSearchError = true;
                break;
            case 'CLEAR_ACTIVE_SEARCH_RESULTS':
                state.activeSearchResults = [];
                state.activeSearchCurrentPage = 1;
                state.activeSearchTotalPages = 1;
                state.activeSearchTotalTemplates = 0;
                break;
            case 'SET_LOADING_MESSAGE':
                state.loadingMessage = action.text;
                break;
            case 'SET_CREATED_APP_MORE_DETAILS':
                state.createdTemplateApp.id = action.appId;
                state.createdTemplateApp.styleId = action.styleId;
                break;
            case 'RESET_SELECTED_TEMPLATE':
                state.selectedTemplate.id = '';
                state.selectedTemplate.colorView = null;
                state.selectedTemplate.typographyView = null;
                state.selectedTemplate.icon = '';
                state.selectedTemplate.appId = '';
                state.selectedTemplate.includeData = false;
                state.selectedTemplate.version = null;
                break;
            case 'DELETE_INCOMPLETE_APP_REQUEST':
                state.deleteLoading = true;
                state.deleteError = false;
                break;
            case 'DELETE_INCOMPLETE_APP_SUCCESS':
                state.deleteLoading = false;
                state.deleteError = false;
                break;
            case 'DELETE_INCOMPLETE_APP_FAILURE':
                state.deleteLoading = false;
                state.deleteError = true;
                break;
            case 'UPDATE_ENVIRONMENT_DATA_REQUEST':
                state.environmentLoading = true;
                state.environmentError = false;
                break;
            case 'UPDATE_ENVIRONMENT_DATA_SUCCESS':
                state.environmentLoading = false;
                state.environmentError = false;
                break;
            case 'UPDATE_ENVIRONMENT_DATA_FAILURE':
                state.environmentLoading = false;
                state.environmentError = true;
                break;
            case 'EDIT_ENVIRONMENT_DATA_STATE':
                state.environmentData[action.index].value = action.value;
                state.environmentLoading = false;
                state.environmentError = false;
                break;
            case 'GET_ENVIRONMENT_DATA_REQUEST':
                state.environmentDataLoading = true;
                state.environmentDataError = false;
                break;
            case 'GET_ENVIRONMENT_DATA_SUCCESS':
                state.environmentData = action.data;
                state.environmentDataLoading = false;
                state.environmentDataError = false;
                break;
            case 'GET_ENVIRONMENT_DATA_FAILURE':
                state.environmentDataLoading = false;
                state.environmentDataError = true;
                break;
            case 'CHANGE_REQUEST_MODAL_STATE':
                state.requestTemplate = action.open;
                break;
            case 'SET_ENV_VALIDATIONS':
                state.allRequiredEnvs = action.status;
                break;
            case 'SET_IS_CONTINUE_DISABLED':
                state.isContinueDisabled = action.disabled;
                break;
            case 'STYLE_DATA_REQUEST':
                state.styleDataLoading = true;
                state.styleDataError = false;
                break;
            case 'STYLE_DATA_SUCCESS':
                state.styleData = action.styleObj;
                state.data = action.styleObj;
                state.styleName = action.styleName;
                state.styleDescription = action.styleDescription;
                state.styleDataLoading = false;
                state.styleDataError = false;
                break;
            case 'STYLE_DATA_FAILURE':
                state.styleDataLoading = false;
                state.styleDataError = true;
                break;
            case 'IS_QUOTA_AVAILABLE_POPOVER_OPEN':
                state.isNoQuotaOpen = action.open;
                break;
            default:
                break;
        }
    });
}
export default createAppFlowReducer;
